(() => {
  const dialog = document.getElementById('DaisySignupOffer');
  const config = JSON.parse(document.getElementById('DaisySignupOfferConfig').textContent);
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = `daisy:signup-offer:${config.theme}`;
  const cookie = `daisy_offer_seen_${config.theme}`;
  const launcher = document.querySelector('[data-offer-launcher]');
  const status = dialog.querySelector('[data-offer-status]');
  let state = { seen: false, dismissed: false, step: 'email', email: '' };
  try { state = { ...state, ...JSON.parse(sessionStorage.getItem(key) || '{}') }; } catch {}
  if (document.cookie.split('; ').some(c => c === `${cookie}=1`)) state.seen = true;
  if (!['email','sms','success'].includes(state.step)) state.step = 'email';
  if (!state.entryPath) {
    state.entryPath = location.pathname + location.search;
    state.shopEntry = /^\/products\/daisy-one\/?$/.test(location.pathname) && !new URLSearchParams(location.search).get('view');
    state.entryTime = Date.now();
    try { sessionStorage.setItem(key, JSON.stringify(state)); } catch {}
  }
  let pending = false, previousFocus = null, scrolled = false;
  const fitDialog = () => dialog.style.setProperty('--daisy-offer-scale', String(Math.min(1, (document.documentElement.clientWidth - 40) / 400)));
  fitDialog();
  window.DaisySignupOffer = { usesCartCheckout: () => Boolean(state.discountCode) };
  const loadImages = () => dialog.querySelectorAll('[data-offer-src]').forEach(img => {
    if (img.closest('.daisy-offer__desktop-photo') && innerWidth < 990) return;
    if (!img.getAttribute('src')) img.src = img.dataset.offerSrc;
  });
  const persist = () => {
    try { sessionStorage.setItem(key, JSON.stringify(state)); } catch {}
    if (state.seen) document.cookie = `${cookie}=1; Path=/; SameSite=Lax; Secure`;
  };
  const paint = () => {
    dialog.dataset.step = state.step;
    dialog.querySelectorAll('[data-offer-form]').forEach(f => { f.hidden = f.dataset.offerForm !== state.step; });
    dialog.querySelector('.daisy-offer__success').hidden = state.step !== 'success';
    dialog.querySelectorAll('[data-offer-picture]').forEach(img => { img.hidden = img.dataset.offerPicture !== state.step; });
    launcher.hidden = dialog.open || !state.seen || state.dismissed || state.step === 'success';
    if (dialog.open) loadImages();
  };
  const open = () => {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    state.seen = true; state.dismissed = false; persist();
    dialog.showModal(); document.documentElement.classList.add('daisy-offer-open'); paint();
    // Avoid opening the phone keyboard automatically or jumping the underlying page.
    dialog.focus({ preventScroll:true });
  };
  const close = () => {
    dialog.close(); document.documentElement.classList.remove('daisy-offer-open'); persist(); paint();
    previousFocus?.focus?.({ preventScroll:true });
  };
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r=dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close(); } });
  dialog.querySelector('[data-offer-minimize]').addEventListener('click', close);
  launcher.querySelector('[data-offer-reopen]').addEventListener('click', open);
  launcher.querySelector('[data-offer-dismiss]').addEventListener('click', () => { state.dismissed = true; persist(); paint(); });
  dialog.querySelector('[data-offer-shop]').addEventListener('click', close);
  const request = async (url, options = {}) => {
    const controller = new AbortController(); const timer=setTimeout(()=>controller.abort(),20000);
    try { const response=await fetch(url,{...options,signal:controller.signal}); if(!response.ok)throw Error('Request failed'); return response; }
    finally { clearTimeout(timer); }
  };
  const subscribe = async (attributes, channel) => request(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(config.company)}`, {
    method:'POST',headers:{'Content-Type':'application/json',revision:'2026-07-15'},
    body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Daisy September Signup Offer',profile:{data:{type:'profile',attributes:{...attributes,subscriptions:{[channel]:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:config.list}}}}})
  });
  const applyOffer = async () => {
    if (!config.code) throw Error('Offer is not configured yet. Please try again later.');
    // Completing this signup explicitly selects the popup offer, replacing prior codes.
    const applied = await (await request(`${config.root}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:config.code})})).json();
    const discount=applied.discount_codes?.find(c=>c.code?.toLowerCase()===config.code.toLowerCase());
    if(!discount || (applied.item_count && !discount.applicable)) throw Error('We could not apply your discount. Please try again.');
    state.discountCode=config.code;
    try { localStorage.removeItem('daisy:restock26:email-visitor'); } catch {}
    const url = new URL(location.href);
    if ((url.searchParams.get('offer') || '').toLowerCase() === 'restock26') {
      url.searchParams.delete('offer');
      history.replaceState(history.state, '', url);
    }
    document.dispatchEvent(new CustomEvent('daisy:signup-offer-applied',{detail:{code:config.code}}));
  };
  dialog.querySelectorAll('[data-offer-form]').forEach(form => form.addEventListener('submit', async event => {
    event.preventDefault();
    if (pending || !form.reportValidity()) return;
    if (!config.code) { status.textContent='Offer setup is pending. Please try again later.'; return; }
    const step=form.dataset.offerForm;
    let phone='';
    if(step==='sms'){
      const digits=form.elements.phone.value.replace(/\D/g,'');
      phone=digits.length===10?`+1${digits}`:digits.length===11&&digits.startsWith('1')?`+${digits}`:'';
      if(!/^\+1[2-9]\d{2}[2-9]\d{6}$/.test(phone)){status.textContent='Please enter a valid US phone number.';form.elements.phone.focus();return;}
    }
    pending=true;form.querySelector('button').disabled=true;status.textContent='';
    try {
      if(step==='email'){
        const email=form.elements.email.value.trim();
        await subscribe({email},'email'); state.email=email; state.step='sms';
      }else{
        if (state.submittedPhone !== phone) {
          await subscribe({email:state.email,phone_number:phone},'sms');
          state.submittedPhone=phone;persist();
        }
        await applyOffer(); state.step='success'; state.email=''; form.reset();
        delete state.submittedPhone;
      }
      persist();paint();window.DaisyPurchase?.refresh();dialog.scrollTop=0;dialog.focus({preventScroll:true});
    }catch(error){status.textContent=error.message.startsWith('Offer ')||error.message.startsWith('We could not apply')?error.message:'We could not confirm your signup. Please try again.';}
    finally{pending=false;form.querySelector('button').disabled=false;}
  }));
  const visible = el => el && el.getBoundingClientRect().height > 100 && getComputedStyle(el).visibility !== 'hidden' && el.getClientRects().length;
  const trigger = () => {
    if (state.shopEntry || !scrolled || state.seen || document.documentElement.classList.contains('daisy-mobile-menu-open') || document.querySelector('dialog[open],cart-drawer.active')) return;
    const hero=[...document.querySelectorAll('.fmh-top,.fdh-hero,[id^="FigmaEcomm-"],.fdp-ecomm,.smp-hero,.dp-hero,.fds-hero,.fdb-hero')].find(visible);
    const header=document.querySelector(innerWidth<990?'[data-daisy-mobile-header]':'.figma-desktop-header');
    const headerHeight=header?.getBoundingClientRect().height||0;
    const threshold=hero?hero.getBoundingClientRect().bottom+scrollY-headerHeight:innerHeight;
    if(scrollY>=Math.max(100,threshold)) { open(); window.removeEventListener('scroll',onScroll); }
  };
  let frame=0;
  const onScroll=()=>{scrolled=true;loadImages();if(!frame)frame=requestAnimationFrame(()=>{frame=0;trigger();});};
  paint();
  if(!state.seen)window.addEventListener('scroll',onScroll,{passive:true});
  if (!state.seen && state.shopEntry) {
    loadImages();
    const showOnShopEntry = () => {
      if (state.seen) return;
      if (document.hidden || document.querySelector('dialog[open],cart-drawer.active') || document.documentElement.classList.contains('daisy-mobile-menu-open')) {
        setTimeout(showOnShopEntry, 500);
        return;
      }
      open();
      window.removeEventListener('scroll', onScroll);
    };
    setTimeout(showOnShopEntry, Math.max(0, 3000 - (Date.now() - state.entryTime)));
  }
  window.addEventListener('pageshow',event=>{if(event.persisted&&dialog.open)close();paint();});
  window.addEventListener('resize',()=>{fitDialog();if(dialog.open)paint();});
})();
